import {Component, Inject, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSelect, MatSelectChange} from '@angular/material';
import {BlockService} from '../../../service/BlockService';
import {MessageService} from '../../../service/message.service';
import {messageTypes} from '../../../helpers/MessageTypes';
import {MAX_DEPASSMENT} from '../../../helpers/GlobalConstants';
import {BlockTempsComponent} from '../block-temps.component';
import * as moment from 'moment';
import * as _ from 'underscore';
import {BLOCKS_EVENT, time_convert} from '../../../vendors/visavail/ResizeSplitBlock';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TypeBlock, TypeBlockLabel} from '../../../model/TypeBlock';
import {AlertService} from '../../../service/alert.service';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {FlowDTO, ProjectDTO} from '../../../model/ProjectDTO';
import {flow} from 'lodash';
import {environment} from "../../../../environments/environment";

declare const _clone: any;

@Component({
  selector: 'app-mutualisation-dialog',
  templateUrl: './mutualisation-dialog.component.html',
  styleUrls: ['./mutualisation-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MutualisationDialogComponent implements OnInit {
  user: any;
  loadingIndicator = false;
  loadingMessage = '';
  breakOverflowDurations: any;
  breakOverflowLimitDepassment: any;
  instance: BlockTempsComponent;
  renderData: any;
  blockRealised: Array<any> = [];
  config: any;
  hasErrorMessage: { code: number | null; message: string } = {code: null, message: null};

  regexFormatDatInput = /[0-9]{4,4}-[0-9]{2,2}-[0-9]{2,2}[\s]{1,1}[0-9]{2,2}:[0-9]{2,2}/gm;
  minPercentage = 0;
  valuePercentage = 50;
  searchItems = '';
  searchProperties: string[] = ['name', 'client'];
  selectedGroups: Set<any> = new Set();
  selectedFlows: Set<any> = new Set();
  form: FormGroup;
  @ViewChildren(MatSelect) matSelects: QueryList<MatSelect>;
  uoData: any;




  constructor(public dialogRef: MatDialogRef<MutualisationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private alert: AlertService,
              private fb: FormBuilder,
              private blockservice: BlockService,
              private messageService: MessageService,
              private http: HttpClient) {
    const {data: instance} = data;
    const {renderData, componentBlockTemps} = instance;
    this.instance = componentBlockTemps;
    this.renderData = Object.assign({}, {...renderData});
    this.form = this.fb.group({});

  }

  uoControl = new FormControl('', [Validators.required]);

  uoMock: any;

  uos: Array<ProjectDTO> = [];
  uosFiltered: Array<ProjectDTO> = [];

  allIdsFullfilled: Array<any> = [];
  uoSelected: any = {};
  splitBlock: any = {};
  selectedProjectsList: any[][] = [];
  isConfiremed = false;
  dropDownOpened = false;
  blocksCount: number = 0;

  async ngOnInit() {
    this.loadingIndicator = true;
    this.loadingMessage = 'FETCH_UO_OF_COLLABORATOR';
    const resp: { response: Array<any>, status: boolean, message: null | HttpErrorResponse } =
      await this.blockservice.getUOByUserName(this.instance.newuser);

    // sort alpha A-Z
    resp.response = resp.response.sort(function(a: any, b: any) { return a.client < b.client ? -1 : 1; });

    const respdata: { response: Array<any>, status: boolean, message: null | HttpErrorResponse } =
      await this.blockservice.getMutualisation(this.instance.newuser, moment(this.instance.data.user.date).format('YYYY-MM-DD'));

    console.log('respdata:', respdata);
    this.uos = resp.response;
    this.uosFiltered = resp.response;

    if (!respdata.status && respdata.message instanceof HttpErrorResponse) {
      this.hasErrorMessage = {
        code: respdata.message.status, // code of invalid fields
        message: respdata.message.message
      };
      this.loadingIndicator = false;
      this.loadingMessage = '';
    } else if (!resp.status && resp.message instanceof HttpErrorResponse) {
      this.hasErrorMessage = {
        code: resp.message.status, // code of invalid fields
        message: resp.message.message
      };
      this.loadingIndicator = false;
      this.loadingMessage = '';
    } else if (!this.uos.length && resp.status) {
      this.hasErrorMessage = {
        code: 302, // code of invalid fields
        message: '(0) UO<small>(s)</small>'
      };
      this.loadingIndicator = false;
      this.loadingMessage = '';
    } else {

      const splitDate: Array<{ date: string; uos: Array<any> }> = (respdata.response as any)
        .next(({current, workAt, prev, next, push, index}) => {
          if (current.end == next.start) {
            push({date: current.end, uos: [_clone(current), _clone(next)], isOne: false});
          } else {
            push({date: current.end, uos: [_clone(current)], isOne: true});
          }
        });

      setTimeout(() => {
        const c = this.config && this.config.splited ? this.config : this.instance.data;
        const FULFILLED_INCOHERENCE: Array<any> = (
          JSON.parse((JSON.stringify(c.temps_data.filter(e => e.name == 'FULFILLED_INCOHERENCE' && e.id != -1)))) as Array<any>
        );
        this.allIdsFullfilled = FULFILLED_INCOHERENCE.map(e => e.id);
        this.config = this.render(undefined, splitDate);
        this.renderBlock();

        for (let i = 0; i < this.blockRealised.length; i++) {
          this.selectedFlows[i] = new Set<string>();
          this.selectedGroups[i] = new Set<string>();
          this.blocksCount++ ;
        }
        this.setSelectedProjectAndFlows();
        this.loadingIndicator = false;
        this.loadingMessage = '';

      }, 1000);
    }
    this.uoData = await this.fetchUoMockData(this.instance.newuser);
    this.uoMock = this.uoData[0];
  }

  checkIdExists(flows, desiredId) {
    return flows.some(fl => fl.id === desiredId);

  }
  setSelectedProjectAndFlows() {
    this.blockRealised.forEach((block, index) => {
      if (block.uoSelected) {
        const uoMapped = this.uos.find(uo => uo.name === block.uoSelected.uo);
        if (uoMapped) {
          this.selectedGroups[index].add(uoMapped);
          this.setDefaultProject(index, [uoMapped]);
          if (uoMapped.flows && block.uoSelected.flowIds) {
            block.uoSelected.flowIds.forEach(flowId => {
              if (this.checkIdExists(uoMapped.flows, flowId)){
                const flowSelected = uoMapped.flows.find(fl => fl.id === flowId);
                this.selectedFlows[index].add(flowSelected);
              }
            });
          }
        }
        this.onSelectUo(block, block.index);
      } else {
        const uoMock = this.uos.find(uo => uo.name+'' === (this.uoMock?this.uoMock.uo:'')+'');
        if (uoMock) {
          this.selectedGroups[index].add(uoMock);
          this.setDefaultProject(index, [uoMock]);
          if (uoMock.flows && this.uoMock.flowIds) {
            this.uoMock.flowIds.forEach(flowId => {
              if (this.checkIdExists(uoMock.flows, flowId)) {
                const flowSelected = uoMock.flows.find(fl => fl.id === flowId);
                this.selectedFlows[index].add(flowSelected);
              }
            });
          }
        }
        this.onSelectUo(block, block.index);
      }
    });
  }

  setDefaultProject(index: number, projects: any[]) {
    this.selectedProjectsList[index] = projects;
  }

  getUoSelected(block, key?) {
    const uos = (this.uoSelected[block.index] || {uos: []}).uos;
    const f = uos.find((e: any) => e.index == block.id);
    const o = (f || {origin: {projectCode: null, name: '-', client: '-'}});
    const {name, client} = o.origin;
    return key ? o.origin[key] : [client, name].join(' - ') || '-';
  }


  onSelectUo(block , index)  {
    if (this.selectedGroups[index]) {
      // const ProjectArray = Array.from(this.selectedGroups[index]);

      const FlowsArray = Array.from(this.selectedFlows[index]);
      const ProjectArray = Array.from(this.selectedGroups[index]);
      const flow = (FlowsArray[0] as FlowDTO);
      const project = (ProjectArray[0] as any);
      let Project ;
      if (flow) {
        Project = block.uos.find(uo => uo.projectCode === flow.projectId );
      }else if (project){
        Project = block.uos.find(uo => uo.projectCode === project.projectCode);
      }
      // const value = (ProjectArray[0] as ProjectDTO);
      const uoBlock = this.uoSelected[block.index] || {uo: Project, uos: [], idsMerged: block.idsMerged};
      uoBlock.uo = Project;
      uoBlock.idsMerged = block.idsMerged;
      uoBlock.uos = uoBlock.uos.filter(e => e.index != `${block.id}`);
      const date = moment(block.start).subtract(this.blockservice.tzService.tz, 'hours').format('YYYY-MM-DDTHH:mm');
      if (Project) {
        uoBlock.uos.push({
          index: `${block.id}`,
          origin: Project,
          flows: FlowsArray,
          uo: Project.projectCode,
          uoName: Project.name,
          date,
        });
      }
      uoBlock.uos = _.sortBy(uoBlock.uos, 'date');
      console.log('uoBlock:', uoBlock);
      this.uoSelected[block.index] = uoBlock;
      this.setDefaultProject(index, [Project]);
    }

  }

  toggleGroupSelection(uo: ProjectDTO, index: number) {
    if (!this.isGroupSelected(uo, index) && this.selectedGroups[index] && this.selectedFlows[index]) {
      // Clear selectedGroups and selectedFlows only when selecting a new group
      this.selectedGroups[index].clear();
      this.selectedFlows[index].clear();
    }
    if (this.isGroupSelected(uo, index)) {
      this.selectedGroups[index].delete(uo);
      if(uo.flows && uo.flows.length > 0)
        uo.flows.forEach((flux: any) => {
          this.selectedFlows[index].delete(flux);
        });
    } else {
      this.selectedGroups[index].add(uo);
      if(uo.flows && uo.flows.length > 0)
        uo.flows.forEach((flux: any) => {
          this.selectedFlows[index].add(flux);
        });
    }
  }

  toggleFlowSelection(block, uo: ProjectDTO, flow: any, index: number) {
    if (this.isFluxSelected(flow, index)) {
      this.selectedFlows[index].delete(flow);
      this.selectedGroups[index].delete(uo);
    } else {
      const isSelected = this.isFlowAssociatedWithSelectedGroups(flow, this.selectedGroups[index]);
      if (!isSelected) {
        this.selectedGroups[index].clear();
        this.selectedFlows[index].clear();
      }
      this.selectedGroups[index].add(uo);
      this.selectedFlows[index].add(flow);
    }
  }

  confirmDropDown(matSelect: MatSelect, block, index) {
    this.dropDownOpened = false;
    this.isConfiremed = true;
    this.blockRealised.forEach(b=> b.searchItems = "");
    // if (block.splited === undefined) {
    this.onSelectUo(block, index);
    // }
    matSelect.close();
  }

  closeDropDown(matSelect: MatSelect, index) {
    this.dropDownOpened = false;
    this.blockRealised.forEach(b=> b.searchItems = "");
/*    this.clearSelection(index);
    const uoMapped = this.uos.find(uo => uo.name === this.blockRealised[index].uoSelected.uo);
    this.selectedGroups[index].add(uoMapped);
    this.setDefaultProject(index, [uoMapped]);
    if (uoMapped.flows && this.blockRealised[index].uoSelected.flowIds) {
      this.blockRealised[index].uoSelected.flowIds.forEach(flowId => {
        if (this.checkIdExists(uoMapped.flows, flowId)) {
          const flowSelected = uoMapped.flows.find(fl => fl.id === flowId);
          this.selectedFlows[index].add(flowSelected);
        }
      });

    }*/
    matSelect.close();
  }

  closeClickedtDropDown (matSelect: MatSelect, index) {
    this.dropDownOpened = false;
    if (!this.isConfiremed) {
      this.clearSelection(index);
      if (this.blockRealised[index].uoSelected) {
        const uoMapped = this.uos.find(uo => uo.name === this.blockRealised[index].uoSelected.uo);
        this.selectedGroups[index].add(uoMapped);
        this.setDefaultProject(index, [uoMapped]);
        if (uoMapped.flows && this.blockRealised[index].uoSelected.flowIds) {
          this.blockRealised[index].uoSelected.flowIds.forEach(flowId => {
            if (this.checkIdExists(uoMapped.flows, flowId)) {
              const flowSelected = uoMapped.flows.find(fl => fl.id === flowId);
              this.selectedFlows[index].add(flowSelected);
            }
          });

        }
      } else {
        const uoMock = this.uos.find(uo => uo.name+'' === (this.uoMock?this.uoMock.uo:'')+'');
        if (uoMock) {
          this.selectedGroups[index].add(uoMock);
          this.setDefaultProject(index, [uoMock]);
          if (uoMock.flows && this.uoMock.flowIds) {
            this.uoMock.flowIds.forEach(flowId => {
              if (this.checkIdExists(uoMock.flows, flowId)) {
                const flowSelected = uoMock.flows.find(fl => fl.id === flowId);
                this.selectedFlows[index].add(flowSelected);
              }
            });
          }
        }
      }
      matSelect.close();
    }
    this.isConfiremed = false;
  }

  openDropDown() {
    this.dropDownOpened = true;
  }

  isFlowAssociatedWithSelectedGroups(flow: any, selectedGroups: Set<any>): boolean {
    let isAssociated = false;
    selectedGroups.forEach(group => {
      if (group.flows && group.flows.includes(flow)) {
        isAssociated = true;
        return;
      }
    });
    return isAssociated;
  }

  clearSelection(index) {
    this.selectedGroups[index].clear();
    this.selectedFlows[index].clear();
  }



  isGroupSelected(group: any, index: number): boolean {
    if(!group) return false;
    if (group.flows  && group.flows.length > 0) {
      const isAll = group.flows.every((flow) =>
        this.selectedFlows[index] && this.selectedFlows[index].has(flow)
      );
      return isAll;
    }else {
      return this.selectedGroups[index] && this.selectedGroups[index].has(group);
    }
  }

  isFluxSelected(flow: any, index: number): boolean {
    if (this.selectedFlows[index]) {
      return this.selectedFlows[index] && this.selectedFlows[index].has(flow);
    }
  }


  getSelectedNames(block, index: number): string {
    if (this.selectedGroups[index].size > 0) {
      const selectedGroup = this.selectedGroups[index].values().next().value;

      if (selectedGroup) {
        return selectedGroup.name;
      }
    }
    return 'Projet';
  }

  getFlowsCount(index) {
    if (this.selectedFlows[index] && this.selectedFlows[index].size > 0 ) {
      return '(' + this.selectedFlows[index].size + ')';
    }
    return '';
  }

  displayTooltip(index: number): string {
    if (this.selectedGroups[index] && this.selectedFlows[index]) {
      const FlowsArray = Array.from(this.selectedFlows[index]);
      const flow = (FlowsArray[0] as FlowDTO);
      if (flow){
        const selectedProject = this.uos.find(uo => uo.projectCode === flow.projectId );

        // const selectedGroup = this.selectedGroups[index].values().next().value;
        const selectedFlows = this.selectedFlows[index];

        if (selectedProject) {
          const groupText = selectedProject.name;
          let flowTextArray = [];

          if (selectedFlows) {
            selectedFlows.forEach(selectedFlow => {
              if (selectedFlow) {
                flowTextArray.push(selectedFlow.name);
              }
            });

            if (flowTextArray.length > 0) {
              // Use join to concatenate flow names with '|'
              const flowText = flowTextArray.join('|');
              return selectedProject.client + '-' + groupText + '/' + flowText;
            }
          }

          return selectedProject.client + '-' + groupText;
        }
      } else {
          const ProjectArray = Array.from(this.selectedGroups[index]);
          const project = (ProjectArray[0] as any);
          return project?project.client + '-' + project.name:"-";
      }
    }
    return '-';
  }


  getUoNName(uo, index): string {
    return this.dropDownOpened ? uo.client + ' - ' + uo.name : this.getFlowsCount(index) + ' ' + uo.client + ' - ' + uo.name ;
  }

  getTriggerUo(uo): string {
    return  uo[0].name ;
  }

  truncateText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }






  renderBlock() {
    this.instance.renderBlock('.mutualisation', this.config, {
      onResize: (libs) => {
        const {line, date, id, mapNewLine} = libs;
        const nConfig = this.render([date]);
        this.config = nConfig;
        this.renderBlock();
      }
    }, true);
  }


  public CloseDialog() {
    this.dialogRef.close();
    this.messageService.sendMessage(messageTypes.LOADING);
  }

  async Validation() {
    const translateService = this.instance.translate;
    const translate = translateService.translations[translateService.currentLang];
    this.hasErrorMessage = {code: null, message: null};
    const data = {
      ids: this.allIdsFullfilled,
      blocks: Object.values(this.uoSelected).map(e => ({blockIdsMerged: e.idsMerged, uos: e.uos}))
    };
    // set date index == 0 equal null
    data.blocks.forEach(e => {
      e.uos = e.uos.map((c, i) => {
        return {date: i == 0 ? null : c.date, uo: c.uo, flows: c.flows, uoName: c.uoName};
      });
    });
    if (this.blockRealised.length == data.blocks.map(e => e.uos.length).reduce((p, c) => p + c, 0)) {
      console.log('response >>', data);
      this.blockservice.saveBlocksMutualisation(data).subscribe(() => {
        this.hasErrorMessage.code = 200;
        this.hasErrorMessage.message = 'Success';
      }, err => {
        this.hasErrorMessage = err;
      }, () => {
        if (this.hasErrorMessage.code == 200) {
          setTimeout(() => {
            this.dialogRef.close();
          }, 1e3);
        }
      });
    } else {
      this.hasErrorMessage = {
        code: 301, // code of invalid fields
        message: translate.BLOCK_TEMPS['MSG_ERROR_MUTUALISATION']
      };
    }
    //console.log("response >>", response)
  }


  render(resizeDates?: Array<any>, splits?: Array<any>) {
    const translateService = this.instance.translate;
    const translate = translateService.translations[translateService.currentLang];
    const REALIZED_VALIDATED = String(translate.BLOCK_TEMPS.BLOCKS[TypeBlockLabel['REALIZED_VALIDATED']]).toLowerCase();

    if (resizeDates && resizeDates.length > 1) {
      const date = resizeDates[0][0][1];
      const id = resizeDates[0][0][2];
      this.splitBlock[moment(date).format('YYYY-MM-DD HH:mm')] = id;
      console.log('>>>>', );
    }
    const c = this.config && this.config.splited ? this.config : this.instance.data;
    const username = this.instance.newuser;
    let data = JSON.parse((JSON.stringify(c.temps_data.filter(e => e.name == 'FULFILLED_INCOHERENCE' && e.id != -1 && (!e.motif || (e.motif && (e.motif.paied || (!e.motif.paied && e.legend == 'INSERVICE'))))))));
    data = this.excludeBlockHasSumStartEnd(data);
    const date = this.renderData.user.date;
    if ((!this.config || (this.config && !this.config.splited)) || splits) {
      data = this.mergeBlockV2(data, splits);
    }

    //config.temps_data = this.mergeBlockV2(config.temps_data);
    if (resizeDates && resizeDates.length) {
      resizeDates.forEach((blockSplit) => {
        const [date1, date2, id] = blockSplit[0];
        let block = data.find(e => String(e.id) == String(id));
        data = data.filter(e => e.id != id);
        if (block) {
          blockSplit.forEach((nDate, i) => {
            block = JSON.parse(JSON.stringify(block));
            block.start = new Date(this.formateDate(nDate[0]));
            block.end = new Date(this.formateDate(nDate[1]));
            block.id = i == 0 ? block.id : parseInt(this.generate(4));
            block.tz = 0;
            block['action'] = 'BY_SPLIT';
            block['splited'] = true;
            //block['first'] = i == 0;
            data.push(block);
          });
        }
      });
    }
    data = _.sortBy(data, (b) => b.start);
    this.blockRealised = data;
    if (this.blockRealised && this.blockRealised.length && this.uos)
      this.blockRealised.forEach(block => block.uos = this.uosFiltered);
    if ((this.blockRealised.length !== this.blocksCount) && (this.blocksCount !== 0)) {
      this.selectedFlows[this.blocksCount] = new Set<string>();
      this.selectedGroups[this.blocksCount] = new Set<string>();
      this.blocksCount++;
    }
    let config = this.instance.blockservice.formatBlockV2(username, date, [...data], []);
    config = JSON.parse(JSON.stringify(config));

    config.view = 'ONLY_DATA';
    config.Display.styles.height = '100px';
    config.Display.styles.width = 200;
    config.Display.styles.margin.top = 0;
    config.stepHours = 1;
    config.enableResize = !this.isValidated();
    config.isActive = !this.isValidated();
    config.tmpBreaks = [];
    config.productionBlock = [...config.temps_data];
    config.dataset = config.dataset.filter(e => e.caption.toLowerCase() == REALIZED_VALIDATED && !e.key);


    if (config.dataset.length) {
      config.dataset[0].data = _.sortBy(config.dataset[0].data, 'start').map(d => {
        d[0] = moment(d[0], 'YYYY-MM-DD HH:mm:ss').add(1 ,'hours').toDate();
        d[1] = d[1] == 'EMPTY' ? 'EMPTY' : 'FULFILLED_VALIDATED_INSERVICE_BYUSER';
        return d;
      });
      if ((resizeDates && resizeDates.length) || (splits && splits.length)) {
        config.splited = true;
      }
    }
    this.blockRealised = this.getBlockSorted(this.blockRealised);
    if (this.blockRealised && this.blockRealised.length && this.uos)
      this.blockRealised.forEach(block => block.uos = this.uosFiltered);
    return config;
  }

  isValidated() {
    return this.instance.conditionValidationButton.isValidateFULFILLED_INCOHERENCE;
  }

  excludeBlockHasSumStartEnd(blocks: Array<any>) {
    return (blocks || []).filter(b => {
      const s = new Date(b.start);
      const e = new Date(b.end);
      s.setSeconds(0);
      e.setSeconds(0);

      return s.getTime() != e.getTime();
    });
  }

  generate(n) {
    let add = 1,
      max = 12 - add;

    if (n > max) {
      return this.generate(max) + this.generate(n - max);
    }

    max = Math.pow(10, n + add);
    const min = max / 10; // Math.pow(10, n) basically
    const number = Math.floor(Math.random() * (max - min + 1)) + min;

    return ('' + number).substring(add);
  }

  mergeBlockV2(data: any, splits?: Array<any>) {
    if (!data.length) { return data; }
    data = data.filter(e => !e.duration);
    let idsMerged = [];
    data = data.next(({current, workAt, prev, next, push, index}) => {
      const s = new Date(next.start);
      const e = new Date(current.end);
      s.setSeconds(0);
      e.setSeconds(0);
      const st = s.getTime();
      const et = e.getTime();
      idsMerged.push(current.id);
      if (st == et) {
        workAt.end = next.end;
        idsMerged.push(next.id);
      }
      if (!(st == et)) {
        workAt['idsMerged'] = Array.from(new Set([...idsMerged]));
        push(workAt);
        idsMerged = [];
      }
      return !(st == et);
    });
    let o: any = data.filter(e => !e.remove).map((b, index) => {
      b.tzStr = b.tz < 0 ? b.tz : '+' + b.tz;
      return this.iniBlock({
        index: index,
        uo: b.uo,
        id: b.id,
        start: b.start,
        end: b.end,
        tz: b.tz,
        user: b.user,
        idsMerged: b.idsMerged,
        first: b.first
      });
    });
    if (splits && Array.isArray(splits)) {
      splits.forEach((b) => {
        o = o.next(({current, workAt, prev, next, push, index}) => {
          const date = moment(String(b.date).replace('T', ' ')).add(this.blockservice.tzService.tz, 'hours');
          const start = moment(current.start);
          const end = moment(current.end);
          if (start.isSameOrBefore(date) && end.isSameOrAfter(date) && !b.isOne) {
            push({...current, end: date, uoSelected: _clone(b.uos)[0], splited: true});
            push({
              ...current,
              start: date,
              uoSelected: _clone(b.uos)[1],
              splited: true,
              id: parseInt(this.generate(4))
            });
          } else if (end.isSame(date)) {
            push({...current, uoSelected: b.uos[0], issplited: false});
          } else if (!current.uoSelected) {
            push({...current, uoSelected: b.uos[0], issplited: false});
          } else {
            push({...current, issplited: false});
          }
        });
      });
      o.forEach((b, i) => {
        if (b.uoSelected) {
          this.onSelectUo(b, i);
        }
      });
    }
    return o;
  }

  iniBlock(o: { index: any, id: any, start: any, end: any, tz: any, user: any, uo: any, idsMerged: Array<any>, first: boolean }) {
    const map = Object.assign({
      'uo': {},
      'index': null,
      'id': null,
      'start': null,
      'end': null,
      'type': 'FULFILLED',
      'activityType': 'INSERVICE',
      'blockStatus': 'VALIDATED',
      'user': null,
      'logged': false,
      'locked': 'UNLOCKED',
      'tag': 'Fulfilled',
      'validatedBy': null,
      'validated': null,
      'reclamationStatus': null,
      'source': 'SYSTEM',
      'tad': false,
      'tz': 0,
      'name': 'FULFILLED_INCOHERENCE',
      'legend': 'FULFILLED_VALIDATED_INSERVICE_BYUSER',
      'idsMerged': [],
      'first': false
    }, o || {});
    return map;
  }

  formateDate(date) {
    return date instanceof Date ? date : date.replace(/(T|Z)/gm, ' ').trim();
  }

  getDate(d, useLocal?) {
    return moment(d).format('YYYY-MM-DD' + (useLocal ? 'T' : ' ') + 'HH:mm');
  }

  getTotalBlock(d) {

    const v = moment(d.end).diff(moment(d.start), 'seconds');
    return  moment.utc(v * 1000).format('HH:mm');
  }

  getBlockSorted(data) {
    return _.sortBy(data, (b) => b.start);
  }

  toggleAction(block) {
    const masterBlock = this.blockRealised.find((b) => b.id == block.masterId);
    if (masterBlock) { masterBlock.btnAction = true; }
  }

  splitBlockByPercentage(block) {
    this.toggleAction(block);
    if (block.hasOwnProperty('updateWithPercentage')) {
      block.updateWithPercentage = !block.updateWithPercentage;
    } else {
      block.updateWithPercentage = true;
      block.action = 'BY_PERCENTAGE';
      this.onUpdatePercentage(block, {value: this.valuePercentage});
    }
  }

  addBlock(block) {
    if (block.hasOwnProperty('btnAction') && !block.btnAction) { return; }
    // disable master action add | percentage on update
    block.btnAction = false;
    // add proprety onUpdate for set date split
    this.blockRealised.push({
      ...block,
      action: 'BY_ADD',
      onUpdate: true,
      id: parseInt(this.generate(4)),
      masterId: block.id
    });
    this.blockRealised = this.getBlockSorted(this.blockRealised);
    if (this.blockRealised && this.blockRealised.length && this.uos)
      this.blockRealised.forEach(block => block.uos = this.uosFiltered);
  }

  setPercentageBlock(block) {
    if (block.hasOwnProperty('oldEnd')) {
      const end = new Date(+block.end);

      const dates = [
        [block.start, end, block.id],
        [end, block.oldEnd, block.id]
      ];
      const nConfig = this.render([dates]);
      this.config = nConfig;
      this.renderBlock();
    }
  }

  removeBlock(block) {
    // remove
    if (block['updateWithPercentage']) {
      // remove hover  block
      const foreignObject = document.querySelector('app-mutualisation-dialog #foreignObject_' + (block.id));
      if (foreignObject) { foreignObject.remove(); }
      // restore value end onCancel
      if (block.hasOwnProperty('oldEnd')) {
        block.end = block.oldEnd;
      }

      delete block['oldEnd'];
      delete block['updateWithPercentage'];
    } else {
      this.toggleAction(block);
      this.blockRealised = this.blockRealised.filter((b) => b.id != block.id);
      this.blockRealised = this.getBlockSorted(this.blockRealised);
      if (this.blockRealised && this.blockRealised.length && this.uos)
        this.blockRealised.forEach(block => block.uos = this.uosFiltered);
    }
  }

  toGMT(v, t) {
    v = new Date(v);
    //v.setHours(v.getHours() - t)
    return v;
  }

  updateBlock(block: any) {
    /*if (!this.hasDuplicated(block)) {
      block.onUpdate = false;
    }*/
    if (block.validityOfStart) {
      const masterBlock = this.blockRealised.find((b) => b.id == block.masterId);
      const {start, end} = block.origin;
      const _start = block._start;
      const _end = block._end;
      const tz = block.tz;
      if (_start && !_end) {
        const dates = [
          [this.toGMT(start, tz), this.toGMT(_start, tz), block.masterId],
          [this.toGMT(_start, tz), this.toGMT(end, tz), block.masterId]
        ];
        const nConfig = this.render([dates]);
        this.config = nConfig;
        this.renderBlock();

      } else if (!_start && _end) {
        const dates = [
          [this.toGMT(start, tz), this.toGMT(_end, tz), block.masterId],
          [this.toGMT(_end, tz), this.toGMT(end, tz), block.masterId]
        ];

        const nConfig = this.render([dates]);
        this.config = nConfig;
        this.renderBlock();

      } else if (_start && _end) {

        const ldates = [
          [
            [this.toGMT(start, tz), this.toGMT(_start, tz), block.masterId],
            [this.toGMT(_start, tz), this.toGMT(_end, tz), block.masterId],
          ],
          [
            [this.toGMT(_start, tz), this.toGMT(_end, tz), block.masterId],
            [this.toGMT(_end, tz), this.toGMT(end, tz), block.masterId],
          ]
        ];
        const nConfig = this.render(ldates);
        this.config = nConfig;
        this.renderBlock();

      }
    }
  }

  hasDuplicated(block) {
    return (this.blockRealised.filter((b) => {
      return (block.start == b.start && block.end == b.end);
    }).length > 0 && block.hasOwnProperty('onUpdate') && block.onUpdate == true);
  }

  onUpdatePercentage(block, input) {
    const value = parseInt(input.value);
    if (value >= this.minPercentage && value <= 100) {
      const {xScale, diffDates} = BLOCKS_EVENT;

      // calc duration & width by percentage
      const duration = diffDates(block.start, block.oldEnd || block.end);
      const maxWidth = (xScale(block.oldEnd || block.end) - xScale(block.start));
      const calc = Math.round(((maxWidth / (100 / value) * duration) / maxWidth));
      const time = time_convert(calc);

      const placeholder = this.findRectinSvgById(block.id);

      if (placeholder) {
        // update rect render block ui
        const rect = placeholder.previousElementSibling.getBoundingClientRect();
        const rectBox = (placeholder.previousElementSibling as any).getBBox();
        placeholder.setAttribute('width', String((rect.width / (100 / value))));
        placeholder.setAttribute('x', String(rectBox.x));

        // update end of block with percentage
        const start = new Date(+block.start);
        start.setHours((start.getHours() + time.hh));
        start.setMinutes(start.getMinutes() + time.mm);

        if (!block.hasOwnProperty('oldEnd')) {
          block.oldEnd = block.end;
        }

        block.end = new Date(+start);
        //block.newEnd = start

      }
    } else {
      /*setTimeout(function () {
        input.value = 10;
      }, 100)*/
    }
  }

  // find [rect + foreignObject] of render block ui
  findRectinSvgById(id) {
    const nodesRect: NodeList = document.querySelectorAll('app-mutualisation-dialog rect');
    const rects: Array<any> = Array.from(nodesRect);
    const rect = rects.find(e => e.data.date_[e.data.date_.length - 1] == id);
    let foreignObject = document.querySelector('app-mutualisation-dialog #foreignObject_' + id);
    if (rect && !foreignObject) {
      rect.insertAdjacentHTML('afterend', '<foreignObject id="foreignObject_' + id + '"  style="transition: all .1s"  width="0" height="15" y="14"><div style="background: #ffffff78;width: 100%;height: 100%;"></div></foreignObject>');
      foreignObject = document.querySelector('app-mutualisation-dialog #foreignObject_' + id);
    }
    return foreignObject;
  }

  checkValidity(date: Date) {
    const s = String(moment(date).format('YYYY-MM-DD hh:mm')).trim();
    const c = this.regexFormatDatInput.test(s);
    const m = moment(date, 'YYYY-MM-DD hh:mm', true).isValid();

    //console.log('checkValidity:', m ,' || ', date, " >> ", moment(date).format("YYYY-MM-DD hh:mm"), c)
    return c;
  }

  checkDate(block, value) {
    let c = false;
    if (block.origin) {
      const {start, end} = block.origin;
      const {s, e} = {s: new Date(start), e: new Date(end)};
      value = new Date(value);
      value.setSeconds(0);
      s.setSeconds(0);
      e.setSeconds(0);
      c = (+value) > (+s) && (+value) < (+e);
    }
    return c;
  }

  setDate(block, key, element) {
    let value = element.value;
    const masterBlock = this.blockRealised.find((b) => b.id == block.masterId);

    block['_' + key] = new Date(value);

    if (!block.hasOwnProperty('origin')) {
      block.origin = {start: block.start, end: block.end};
    }
    const s = new Date(masterBlock.start);
    const e = new Date(masterBlock.end);
    value = new Date(value);
    value.setSeconds(0);
    s.setSeconds(0);
    e.setSeconds(0);

    if (key == 'start' && (+value) == (+s)) {
      delete block['_start'];
    }
    if (key == 'end' && (+value) == (+e)) {
      delete block['_end'];
    }

    const v = this.checkValidity(value);
    const d = this.checkDate(block, value);
    if (key == 'start') {
      block.validityOfStart = d;
      block.validityStartMessage = {
        date: !d ? 'Date Out Range ' : null
      };
      /*if(block.validityOfStart) {
        masterBlock.end = new Date(value)
      } else {
        masterBlock.end = block.origin.end
      }*/
    }
    /*if (key == "end") {
      block.validityOfEnd = d
      block.validityEndtMessage = {
        date: !d ? "Date Out Range" : null
      }
      /!*if(block.validityOfEnd) {
        masterBlock.start = new Date(value)
      } else {
        masterBlock.start = block.origin.start
      }*!/
    }*/

    /*const checkDate = (+block.start) >= (+masterBlock.start) && (+masterBlock.end) <= (+block.end)
    console.log("checkDate:", checkDate)
    if(this.checkValidity(value) && checkDate) {

      if(!block.hasOwnProperty("oldEnd")) { masterBlock.oldEnd = masterBlock.end; }
      masterBlock.end = new Date(value);

      block[key] = new Date(value);

      block['updated'] = true;
      console.log(key, value, block.oldEnd);
    } else {
      delete block['updated'];
    }*/
  }

  getConfigMask(block, key) {
    return {'max': block.end, 'min': block.start, 'value': block[key]};
  }

  split() {
    const split = false;
    const dates = [];
    const d: any = [
      {
        'projectCode': '24334',
        'name': 'Santiane',
        'start': '2022-10-07 08:58:00',
        'end': '2022-10-07 09:30:00'
      },
      {
        'projectCode': '22008336',
        'name': 'Messine Assurance',
        'start': '2022-10-07 09:30:00',
        'end': '2022-10-07 10:00:00'
      },
      {
        'projectCode': '22008336',
        'name': 'Messine Assurance',
        'start': '2022-10-07 10:00:00',
        'end': '2022-10-07 12:30'
      },
      {
        'projectCode': '31457849',
        'name': 'Darty Blanc Brun',
        'start': '2022-10-07 13:30:00',
        'end': '2022-10-07 18:00:00'
      }
    ];

    const splitDates: Array<{ date: string; uos: Array<any> }> = d.next(({current, workAt, prev, next, push, index}) => {
      if (current.end == next.start) {
        push({date: current.end, uos: [current, next], isOne: false});
      } else {
        push({date: current.end, uos: [current], isOne: true});
      }
    });
    const nConfig = this.render([], splitDates);
    this.config = nConfig;
    this.renderBlock();
  }

  async fetchUoMockData(userId) {
    const url = `${environment.api.mscore}project/uo/flowIds?matricule=${userId}`;
    return new Promise((resolve, reject) => {
      this.http.get<any>(url).subscribe(
        data => {
          if(data && Array.isArray(data)) {
            this.uoMock = data[0];
            console.log("data ==>", data[0])
            resolve(data);
            console.log("data ==>", this.uoMock)
          } else {
            resolve([])
          }
        },
        error => {
          console.error('There was an error during the request', error);
          reject(error);
        }
      );
    });
  }

  getTotalBlockRealise() {
    let total = this.blockRealised.reduce((sum, current) => sum + moment(current.end).diff(moment(current.start), 'seconds'), 0);
    total = moment.utc(total * 1000).format('HH:mm')
    return total;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/block-temps/mutualisation-dialog/mutualisation-dialog.component.ts